import React from 'react';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
interface WebLayoutProps {
  children: React.ReactNode;
  showBottomNav?: boolean;
}
export function WebLayout({
  children,
  showBottomNav = true
}: WebLayoutProps) {
  return <div className="min-h-screen bg-game-bg-pink dark:bg-[#1a1d29]" data-id="element-595">
      {/* Desktop Sidebar */}
      <Sidebar data-id="element-596" />

      {/* Main Content */}
      <div className="lg:pl-72" data-id="element-597">
        <main className="min-h-screen pb-24 lg:pb-8" data-id="element-598">{children}</main>
      </div>

      {/* Mobile Bottom Nav */}
      {showBottomNav && <div className="lg:hidden" data-id="element-599">
          <BottomNav data-id="element-600" />
        </div>}
    </div>;
}